import React, { useEffect, useState } from 'react';
import { SwitchModal } from '@catalogo/core-switch-modal';
import { withMetrics } from '@catalogo/core-metrics';
import { createGlobalStyle, css } from 'styled-components';
import { ModalProps, GlobalStyleProps } from './types';

const Modal: React.FC<ModalProps> = ({ history, dispatchMetrics, ...props }): React.ReactElement => {
  const [visible, setVisible] = useState<boolean>(false);
  const [modalName, setModalName] = useState<string>('');

  useEffect(() => {
    const name = getModalName();
    if (visible !== !!name) {
      name && dispatchMetrics('modal:open', { id: name });

      setVisible(!!name);
      setModalName(name || modalName);
    }
  }, [history.location]);

  const getModalName = (): string => {
    const { hash } = history.location;
    const hasModal = hash.indexOf('#modal-') !== -1;

    return hasModal ? hash.replace('#modal-', '') : '';
  };

  const closeModal = (): void => {
    history.push({ ...history.location, hash: '' });
  };

  return (
    <>
      <GlobalStyle visible={visible} />
      <SwitchModal component={modalName} visible={visible} history={history} {...props} closeModal={closeModal} />
    </>
  );
};

export default withMetrics(Modal);

const GlobalStyle = createGlobalStyle<GlobalStyleProps>`
  body {
    ${({ visible }) =>
      visible &&
      css`
        overflow: hidden;
      `}
  }
`;
